import Helper from "./Helper";

class InteractiveStory {
  constructor(config = {}) {
    const { 
      triggerSelector,
      contentSelector
    } = config;
    this.triggerSelector = triggerSelector;
    this.contentSelector = contentSelector;
    this.triggers = document.querySelectorAll(triggerSelector);
    this.contents = document.querySelectorAll(contentSelector);
    this.activeClass = 'active';

    if(this.triggers && this.triggers.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.triggers.forEach((trigger)=>{
        trigger.addEventListener('click', (e) => {
          this.showContent(trigger.dataset.position);
          Helper.addClass(trigger, this.activeClass);
        });
      });
    }

    showContent(position) {
      this.hideActiveContent();
      let contentToShow = document.querySelector(this.contentSelector + '--' + position);

      if ( contentToShow ) {
        Helper.addClass(contentToShow, this.activeClass);
      }
    }

    hideActiveContent(){
      this.triggers.forEach((trigger) => {
        Helper.removeClass(trigger, this.activeClass);
      });
      this.contents.forEach((content) => {
        Helper.removeClass(content, this.activeClass);
      });
    }


}

export default InteractiveStory;